export enum TabValues {
  PAYMENT_DASHBOARD = 'payment-dashboard',
  PAYOUT_TRACKER = 'payout-tracker',
}

export interface PaymentTab {
  label: string;
  route: TabValues;
}

export const PaymentsTabs: PaymentTab[] = [
  { label: 'Payment Dashboard', route: TabValues.PAYMENT_DASHBOARD },
  // The Stripe-payouts tab is hidden: the Payout Tracker lists those payouts too.
  // The /payments/payouts route still resolves for existing links.
  // The days our payouts pay, then Stripe's own payouts (no business day).
  { label: 'Payout Tracker', route: TabValues.PAYOUT_TRACKER },
];

const paymentsTabByLabel = new Map(PaymentsTabs.map(tab => [tab.label, tab]));
const paymentsTabByRoute = new Map(PaymentsTabs.map(tab => [tab.route, tab]));

export function findPaymentTabByLabel(label: string): PaymentTab | undefined {
  return paymentsTabByLabel.get(label);
}

export function findPaymentTabByRoute(route: string): PaymentTab | undefined {
  return paymentsTabByRoute.get(route as TabValues);
}

export const PaymentLedgerStatuses = [
  { label: 'Pending', value: 'pending' },
  { label: 'Failed', value: 'failed' },
  { label: 'Refunded', value: 'refunded' },
  { label: 'Partially Refunded', value: 'partially_refunded' },
  { label: 'Disputed', value: 'disputed' },
  { label: 'Succeeded', value: 'succeeded' },
];

export const DailySettlementStatuses = [
  { label: 'Upcoming', value: 'pending' },
  { label: 'Completed', value: 'paid' },
];

export const PayoutStatuses = [
  { label: 'Completed', value: 'completed' },
  { label: 'Failed', value: 'failed' },
  { label: 'Upcoming', value: 'upcoming' },
  { label: 'In transit', value: 'in_transit' },
  { label: 'Canceled', value: 'canceled' },
];
